import { FC } from 'react';

import { Loader2 } from 'lucide-react';

export const Loader: FC = () => <Loader2 className="animate-spin" />;
